var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1602_1370",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.5H15.1076V15.1077H0.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1602_1370)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80425 1.625C4.397 1.625 1.625 4.39625 1.625 7.8035C1.625 11.2108 4.397 13.9827 7.80425 13.9827C11.2108 13.9827 13.9827 11.2108 13.9827 7.8035C13.9827 4.39625 11.2108 1.625 7.80425 1.625M7.80425 15.1077C3.77675 15.1077 0.5 11.831 0.5 7.8035C0.5 3.776 3.77675 0.5 7.80425 0.5C11.8318 0.5 15.1077 3.776 15.1077 7.8035C15.1077 11.831 11.8318 15.1077 7.80425 15.1077",
    fill: "#0A0B0F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1602_1370",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9302 12.2803H15.6982V16.0413H11.9302V12.2803Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1602_1370)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1359 16.0413C14.9926 16.0413 14.8486 15.9866 14.7384 15.8771L12.0954 13.2416C11.8756 13.0218 11.8749 12.6656 12.0946 12.4458C12.3136 12.2246 12.6699 12.2261 12.8904 12.4443L15.5334 15.0806C15.7531 15.3003 15.7539 15.6558 15.5341 15.8756C15.4246 15.9866 15.2799 16.0413 15.1359 16.0413",
    fill: "#0A0B0F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.4a01fcf068b65f89df17e6b6266fa1b6.svg";
export { ForwardRef as ReactComponent };